import { http } from '../../../libs/util';
import { util_api } from '../../../libs/util_api';

const util = {
  find(id) {
    return http.get('expense_group/find', { id });
  },
  getDetails(ids) {
    return http.get(util_api.expense_group_detail_items, { ids });
  },
  getDetail(id) {
    return http.get(util_api.expense_group_detail, { id });
  },
  deleteInvoice(id) {
    return http.post(util_api.delete_expense_register, { invoice_register_id: id });
  }
};
export default util;
